import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const fade = keyframes`
  0% {
    opacity         : 0;
    background-image: linear-gradient(to right, #eaeaea, transparent);
  }

  25% {
    opacity         : 0.5;
    background-image: linear-gradient(to right, #eaeaea 25%, transparent);
  }

  50% {
    opacity         : 1;
    background-image: linear-gradient(to right, #eaeaea 50%, transparent);
  }

  75% {
    opacity         : 0.5;
    background-image: linear-gradient(to right, #eaeaea 75%, transparent);
  }

  100% {
    opacity         : 0;
    background-color: #eaeaea;
  }
`;

const Skeleton = styled.div`
  width    : ${(props) => props.width || '100%'};
  height   : ${(props) => props.height || '100%'};
  animation: ${fade} 1.25s ease-in-out infinite;
`;

export default Skeleton;
